import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import download from "../../../helpers/download";
import { getRptPtosConfig } from "./services";

const initialState: any = {
  status: "",
  noContent: true
};

export const actionGetRptPtosConfig: any = createAsyncThunk<any, string>(
  "ACTION_GET_RPTPTOS_CONFIG",
  async (reportType, { getState }: any) => {
    const {
      getLojas: { lojaSelected, lojaSelectedInfos: {nome} },
    } = getState();
    
    const result = await getRptPtosConfig({ idLoja: lojaSelected, reportType });
    
    download(result, {ext: reportType, fileName: `relatorio-${nome}`});

    return result
  }
);

const sliceGetRptPtosConfig = createSlice({
  name: "GET_RPTPTOS_CONFIG",
  initialState,
  reducers: {},
  extraReducers: {
    [actionGetRptPtosConfig.pending]: (state) => {
      state.status = "loading";
    },
    [actionGetRptPtosConfig.fulfilled]: (state, { payload: { status } }) => {
      state.status = "success";
      state.noContent = status === 204;
    },
    [actionGetRptPtosConfig.rejected]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceGetRptPtosConfig.reducer;
